// extracted by mini-css-extract-plugin
export default {"selectionBox":"selectionBox_selectionBox__Pz8qU"};